import DATA from '../mockData';

export default DATA;
